import React, { Component } from "react";
import AboutSection from "../sections/AboutSection";
import ExperienceSection from "../sections/ExperianceSection";
import EducationSection from "../sections/EducationSection";
import SkillsSection from "../sections/SkillsSection";
import PersonalProjectSection from "../sections/PersonalProjectSection";
import BlogSection from "../sections/BlogSection";
import ContactUsSection from "../sections/ContactUsSection";
import GallerySection from "../sections/GallerySection";

class HomeContainer extends Component {
  render() {
    return (
      <div>
        <div
          style={{ width: "100%", overflow: "none" }}
          className="container-fluid p-0"
        >
          <AboutSection />
          <ExperienceSection />
          <EducationSection />
          <SkillsSection />
          <PersonalProjectSection />
          <BlogSection />
          <GallerySection />
          <ContactUsSection />
        </div>
      </div>
    );
  }
}

export default HomeContainer;
